import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const VehicleService = {
    list: async (data) => axios.post(API_URL + "/vehicle/list", data).then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/getVehicle/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/vehicle`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (id, data) => axios.post(API_URL + `/vehicle/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/vehicle/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getBrandModels: async (data) => axios.get(API_URL + `/vehicle/get/brandModels?q=${data}`).then(({data}) => data).catch((err) => { throw err }),
    getVehicleType: async () => axios.get(API_URL + `/vehicle/get/vehicleType`).then(({data}) => data).catch((err) => { throw err }),
    getVehicleColor: async () => axios.get(API_URL + `/vehicle/get/vehicleColor`).then(({data}) => data).catch((err) => { throw err }),
    openAssociated: async (id) => axios.get(API_URL + `/occurrence/openSentryView/${id}`).then(({data}) => data).catch((err) => { throw err }),
    vehicleByPlate: async (id) => axios.get(API_URL + `/vehicle/get/vehicleByPlate/${id}`).then(({data}) => data).catch((err) => { throw err }),
    cortexRenavam: async (data) => axios.post(API_URL + `/cortexRenavam/search`, data).then(({data}) => data).catch((err) => { throw err }),
    getVehicleByPlate: async (plate) => axios.get(`${API_URL}/vehicle/get/vehicleByPlate/${plate}`).then(({ data }) => data).catch((err) => { throw err }),
    availableForMaintenance: async () => axios.get(API_URL + `/vehicles/options/maintenance`).then(({data}) => data.data).catch((err) => { throw err }),

}

export default VehicleService;
